import React from 'react';
import environment from 'platform/utilities/environment';
import PropTypes from 'prop-types';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import IntentToFile from 'platform/shared/itf/IntentToFile';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { useSelector } from 'react-redux';
import { CustomItfAlert } from '../components/FormAlerts/CustomItfAlert';
import { loadCorrectFormConfig } from '../reducers/helper';
import { useAutoResolveArtifacts, useCaveManager } from '../cave';

export default function SurvivorsBenefitsApp({ location, children, loggedIn }) {
  const { useFormFeatureToggleSync } = useFeatureToggle();
  // const survivorsBenefitsForm2026VersionEnabled = useSelector(
  //   state => state.featureToggles.survivors_benefits_form_2026_version_enabled,
  // );
  const pdfVersion = useSelector(
    state => state.form.data?.pdfVersion || 'AUG-2025',
  );
  useFormFeatureToggleSync([
    // Feature toggle name & form data key will be the same
    'survivorsBenefitsForm2025VersionEnabled',
    'survivorsBenefitsForm2026VersionEnabled',
    'survivorsBenefitsIdp',
    {
      toggleName: 'survivorsBenefitsIdp',
      formKey: 'view:idpEnabled',
    },
    'survivorsBenefitsFacilitySelector',
    'survivorsBenefitsUpdatedPrefill',
  ]);
  useAutoResolveArtifacts();
  useCaveManager();
  useBrowserMonitoring({
    service: 'survivors-benefits',
    loggedIn,
  });

  // Render with CustomItfAlert for the intent to show custom content.
  const formConfigToUse = loadCorrectFormConfig(pdfVersion);
  const currentLocation = environment.isLocalhost()
    ? {
        ...location,
        search: `${location.search || ''}${
          location.search ? '&' : '?'
        }redirect`,
      }
    : location;
  return (
    <RoutedSavableApp
      formConfig={formConfigToUse}
      currentLocation={currentLocation}
    >
      <IntentToFile
        itfFound={CustomItfAlert}
        itfType="pension"
        location={location}
        disableAutoFocus
      />
      {children}
    </RoutedSavableApp>
  );
}

SurvivorsBenefitsApp.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  loggedIn: PropTypes.bool,
};
